import { List } from 'immutable';
import { useContext } from 'react';
import ConditionBox from '../common/ConditionBox';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerAddFilterButton from './ViewerAddFilterButton';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerConditionsGroupQuickAddFilterContainer = styled.div.withConfig({
  displayName: "ViewerConditionsGroupQuickAddFilter__ViewerConditionsGroupQuickAddFilterContainer",
  componentId: "g9m8do-0"
})(({
  useOnePanel,
  theme
}) => ({
  display: 'inline-block',
  '& > .condition-box': useOnePanel ? {
    borderColor: theme.color['border-core-default']
  } : undefined
}));
const ViewerConditionsGroupQuickAddFilter = ({
  logicGroupIndex,
  logicOperator
}) => {
  const {
    isInEditMode,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  if (!isInEditMode) {
    return null;
  }
  return /*#__PURE__*/_jsx(ViewerConditionsGroupQuickAddFilterContainer, {
    useOnePanel: useOnePanel,
    children: /*#__PURE__*/_jsx(ConditionBox, {
      hasLogicBox: true,
      logicOperator: logicOperator,
      size: "sm",
      children: /*#__PURE__*/_jsx(ViewerAddFilterButton, {
        parentGroupKeyPath: List.of(logicGroupIndex)
      })
    })
  });
};
export default ViewerConditionsGroupQuickAddFilter;